import { useEffect, useState } from 'react';
import { Maximize } from 'lucide-react';

export default function FullscreenManager() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showButton, setShowButton] = useState(true);

  useEffect(() => {
    // Check if already in fullscreen
    const checkFullscreen = () => {
      const inFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      setIsFullscreen(inFullscreen);
      if (inFullscreen) {
        setShowButton(false);
      }
    };

    checkFullscreen();

    // Listen for fullscreen changes
    const handleFullscreenChange = () => {
      checkFullscreen();
      
      // If user exits fullscreen, re-enter it
      if (!document.fullscreenElement && 
          !document.webkitFullscreenElement && 
          !document.mozFullScreenElement && 
          !document.msFullscreenElement) {
        // Give a moment before re-entering
        setTimeout(() => {
          enterFullscreen();
        }, 500);
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  const enterFullscreen = () => {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen().catch(() => {});
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }

    setShowButton(false);
  };

  // Don't show button if already fullscreen
  if (!showButton || isFullscreen) {
    return null;
  }

  return (
    <button
      onClick={enterFullscreen}
      className="fixed top-4 left-4 z-50 bg-[#ff3131] hover:bg-[#ff5050] text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 font-bold transition-all"
      data-testid="fullscreen-button"
    >
      <Maximize size={24} />
      Enter Fullscreen
    </button>
  );
}
